export const styles = {
  container: ["flex", "flex-col", "h-full", "max-w-[486px] ", "w-full"].join(
    " "
  ),
  form: [
    "w-full",
    "sm:mt-16",
    "lg:ml-24",
    "rounded-xl",
    "sm:shadow-lg",
    "flex",
    "flex-col",
    "h-full",
    "sm:h-auto",
    "sm:bg-white",
  ].join(" "),
};
